import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./index.module.css";
import { useEffect, useState } from "react";
import { faClock, faDungeon, faGraduationCap, faLaptopFile, faMoneyBill, faRankingStar, faUnlockKeyhole } from "@fortawesome/free-solid-svg-icons";

const makesArray = [
    {title: 'Expert-Led Video Courses', icon: faGraduationCap},
    {title: 'Learn Anytime, Anywhere', icon: faClock},
    {title: 'Affordable Course Pricing', icon: faMoneyBill},
    {title: 'Job-Ready Skill Training', icon: faLaptopFile},
    {title: 'High Quality Learning', icon: faRankingStar},
    {title: 'Lifetime Course Access', icon: faUnlockKeyhole},
];

const Slider = () => {
  const [index, setIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(1);

  const totalItems = makesArray.length;
  const extendedArray = [...makesArray, ...makesArray]; // Duplicate array for seamless loop

  const updateVisibleCount = () => {
    const width = window.innerWidth;
    if (width <= 430) setVisibleCount(1);
    else if (width <= 576) setVisibleCount(2);
    else if (width <= 774) setVisibleCount(3);
    else if (width <= 1024) setVisibleCount(4);
    else if (width <= 1200) setVisibleCount(5);
    else setVisibleCount(totalItems);
  };

  useEffect(() => {
    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);
    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => prev + 1);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  // Reset index without visual jump when reaching the end of the extended array
  useEffect(() => {
    if (index === totalItems) {
      setTimeout(() => {
        setIndex(0);
      }, 0);
    }
  }, [index, totalItems]);

  const translateX = -(index * (100 / visibleCount));

  return (
    <div className={styles.makesContainer}>
      <div className={styles.makeSec}>
        <div
          className={styles.makeList}
          style={
            visibleCount < 6
              ? {
                  transform: `translateX(${translateX}%)`,
                  transition: index === 0 ? "none" : "transform 0.5s ease-in-out",
                }
              : {}
          }
        >
          {extendedArray.map((make, i) => (
            <div className={styles.makeImgSec} key={i}>
              <FontAwesomeIcon icon={make.icon} alt="logo" className={styles.logoImg} />
              <p className={styles.sloganText}>{make.title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Slider;